import {css, useTheme} from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import medicalClipIcon from 'src/assets/icons/medicalClipIcon.svg';
import {GetStylesFunction} from 'src/js/common/types';

type Props = any;

export const DlMuiMedicalClipIcon: React.FC<Props> = (props) => {
  const theme = useTheme();
  const styles = getStyles({theme});

  return (
    <SvgIcon
      css={styles.medicalClipIcon}
      component={medicalClipIcon}
      inheritViewBox
      {...props}
    />
  );
};

DlMuiMedicalClipIcon.displayName = 'DlMuiMedicalClipIcon';

const getStyles: GetStylesFunction = (options) => ({
  medicalClipIcon: css`
    width: 24px;
    height: 24px;
  `,
});
